import aiChatBrandIcon from "../assets/img/AI_Chat_Assistant_Icon_round.svg";
import "./aiChatBrand.css";

const AiChatBrand = ({ className = "" }) => {
  const rootClassName = className ? `ai-chat-brand ${className}` : "ai-chat-brand";

  return (
    <div className={rootClassName}>
      <div className="ai-chat-brand__icon">
        <img src={aiChatBrandIcon} alt="" />
      </div>
      <div className="ai-chat-brand__copy">
        <div className="ai-chat-brand__title-row">
          <h1>AI Chat Assistant</h1>
          <sup className="ai-chat-brand__beta">BETA</sup>
        </div>
      </div>
    </div>
  );
};

export default AiChatBrand;
